import axiosInstance from 'src/utils/axios';
import type {
  CancelSubscriptionPayload,
  CreateCheckoutSessionSaasPayload,
  CreateUpdateToAnnualSaasSubscriptionLink,
  MerchantSubscription,
  SubscriptionsQuery,
  MerchantSubscriptionsResponse,
  SubscriptionsResponse,
} from './types.api';

//
//

export const SAAS_SUBSCRIPTIONS_API = '/subscriptions/v1/merchant-saas';

//

export const getSubscriptionsAPI = async (
  query: SubscriptionsQuery
): Promise<MerchantSubscriptionsResponse> => {
  const { merchantCode } = query;

  const response = await axiosInstance.get<MerchantSubscriptionsResponse>(
    `${SAAS_SUBSCRIPTIONS_API}/${merchantCode}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const startTrialAPI = async (merchantCode: string, trialSubscription: MerchantSubscription) => {
  const response = await axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/${merchantCode}/start-trial`,
    trialSubscription
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response;
};

export const getSubscriptionPlansAPI = async (query: SubscriptionsQuery): Promise<SubscriptionsResponse> => {
  const { merchantCode } = query;

  const response = await axiosInstance.get<SubscriptionsResponse>(
    `${SAAS_SUBSCRIPTIONS_API}/plans`,
    { params: { merchantCode } }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const updateSaasSubscriptionAPI = async (
  payload: CreateUpdateToAnnualSaasSubscriptionLink
) => {
  const { merchantCode, ...data } = payload;

  const response = await axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/update-confirm-flow/${merchantCode}`,
    JSON.stringify(data)
  );

  return response?.data;
};

export const cancelSubscriptionAPI = async (payload: CancelSubscriptionPayload) => {
  const { merchantCode, ...data } = payload;

  const response = await axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/cancel-flow/${merchantCode}`,
    JSON.stringify(data)
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response?.data;
};

export const updatePaymentMethodAPI = async (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/update-payment-method-flow/${merchantCode}`,
    JSON.stringify(data)
  );
};

export const createSaasSubscriptionAPI = async (
  payload: CreateCheckoutSessionSaasPayload
) => {
  const { merchantCode, ...data } = payload;
  const response = await axiosInstance.post(
    `/purchases/v1/subscription/merchant-saas/checkout-session/${merchantCode}`,
    JSON.stringify(data)
  );

  return response?.data;
};
